import {
  AccessRestrictionModel,
  AccessRestrictionModelAccessTypesEnum,
  AccessRestrictionModelOperationTypesEnum
} from '../generated-v2/access-restriction-model';

export type AccessRestriction = AccessRestrictionModel;
export type AccessTypesEnum = AccessRestrictionModelAccessTypesEnum;
export type OperationTypesEnum = AccessRestrictionModelOperationTypesEnum;
export const AccessTypes = AccessRestrictionModelAccessTypesEnum;
export const OperationTypes = AccessRestrictionModelOperationTypesEnum;
